import { getAdminTabToken } from '@/lib/admin-tab-token';
import { getImpersonationToken } from '@/lib/impersonation-token';
import type { MouseEvent } from 'react';
import { toast } from 'sonner';

/** Keep a tab-scoped identity when an admin previews a customer's draft. */
export function openSiteViewer(event: MouseEvent<HTMLAnchorElement>) {
  if (event.button !== 0 && event.button !== 1) return;
  if (!getImpersonationToken() && !getAdminTabToken()) return;

  event.preventDefault();
  // A noopener link discards sessionStorage, so the viewer otherwise loads as
  // the shared cookie's user. A same-origin blank tab inherits a snapshot of
  // this tab's storage, including the original token expiry. Detach its opener
  // BEFORE loading any content. Nothing is put in a URL or shared storage.
  const viewer = window.open('about:blank', '_blank');
  if (!viewer) {
    toast.error('Allow pop-ups to open the website preview.');
    return;
  }
  viewer.opener = null;
  viewer.location.replace(event.currentTarget.href);
}
